import React from 'react'
import { Route,Redirect } from 'react-router-dom'
import { omit } from 'ramda'
import auth from "utils/auth";
import Loader from 'components/loader'
import { redirectToLogin } from 'shared/helpers/authentication'
import Storage from 'shared/helpers/storage'

class PrivateRoute extends React.Component {

  componentDidMount () {
    this.props.fetchUser()
  }
  renderSubComponent = (props) => {
    const { component: Component  } = this.props
    if (Storage.getItem('accessToken')) {
      if (this.props.hasAccess){
        return (
          <Component
            {...props}
            routes={this.props.routes}
          />
        )
      } else {
        return (
          <Redirect to="/"/>
        )
      }
    }
    redirectToLogin()
    return <Loader />
  }

  render () {
    const rest = omit(['component', 'location', 'isObserver', 'routes'], this.props)
  if (auth.isAuth()) { 
    return <Route {...rest} render={this.renderSubComponent } />
    } else {
    return <Redirect to={`/login`} />
    }
  }
}
export default PrivateRoute